import { firebase } from '@/plugins/firebase';

const functions = firebase.app().functions('asia-northeast1');

export async function createIvsChannel(userId) {
  const oncall = functions.httpsCallable("createIvsChannel");
  const result =  await oncall({
    userId: userId
  });
  return result.data;
}

export async function resetStreamKey(channelArn, streamKeyArn) {
  const oncall = functions.httpsCallable("resetStreamKey");
  const result =  await oncall({
    channelArn: channelArn,
    streamKeyArn: streamKeyArn,
  });
  return result.data;
}

export async function getChannel(channelArn) {
  const oncall = functions.httpsCallable("getChannel");
  const result =  await oncall({
    channelArn: channelArn,
  });
  return result.data;
}

export async function getStreamKey(streamKeyArn) {
  const oncall = functions.httpsCallable("getStreamKey");
  const result = await oncall({
    streamKeyArn: streamKeyArn,
  });
  return result.data;
}
